<template>
  <div class="change-device change-device-next">
    <van-cell-group>
      <van-field
        :value="$route.query.oldSn"
        label="原机具编号"
        placeholder="请输入原机具编号"
        readonly
      />
      <van-field
        :value="$route.query.newSn"
        label="新机具编号"
        placeholder="请输入新机具编号"
        readonly
        :border="false"
      ></van-field>
      <van-field
        :value="$route.query.mer"
        label="商户编号"
        placeholder="请输入商户编号"
        readonly
        :border="false"
      />
      <van-field
        :value="$route.query.merName"
        label="商户姓名"
        placeholder="请输入商户姓名"
        readonly
        :border="false"
      ></van-field>
      <van-field
        :value="$route.query.merSecretTel"
        label="商户手机号"
        placeholder="请输入商户手机号"
        readonly
        :border="false"
      />
      <van-field
        v-model="captchainfo.captcha"
        label="短信验证码"
        placeholder="请输入验证码"
        :border="false"
      >
        <template #button>
          <van-button
            @click="onGetSmsCode"
            size="small"
            type="primary"
            :color="captchainfo.isSend ? '#E0E0E0' : '#E8BC75'"
          >
            {{ captchainfo.text }}
          </van-button>
        </template>
      </van-field>
    </van-cell-group>
    <div @click="onSubmit" class="bottom-btn">
      <span class="text">确认换绑</span>
    </div>
    <div id="captcha"></div>
  </div>
</template>

<script>
import { multiSmsSend, multiChangeBind } from '@/api/merchant/merchant'
export default {
  name: 'change-device',

  data() {
    return {
      captchainfo: {
        //短信验证码
        captcha: '',
        isSend: false,
        text: '获取验证码',
        time: 60
      }
    }
  },

  mounted() {
    window.initNECaptchaYsf(this.sendSms)
  },

  methods: {
    countDown() {
      const timer = setInterval(() => {
        this.captchainfo.time--
        this.captchainfo.text = `${this.captchainfo.time} s`
        if (this.captchainfo.time < 0) {
          clearInterval(timer)
          this.captchainfo.isSend = false
          this.captchainfo.time = 60
          this.captchainfo.text = '重新获取'
        }
      }, 1000)
    },
    onGetSmsCode() {
      if (this.captchainfo.isSend) {
        return
      }
      captchaIns.refresh()
      captchaIns && captchaIns.popUp()
    },
    sendSms(validateCode) {
      let params = {
        oldSn: this.$route.query.oldSn || '86837040000776',
        validateCode
      }
      console.log(params)
      multiSmsSend(params)
        .then(res => {
          console.log(res)
          this.$toast('验证码发送成功')
          this.captchainfo.isSend = true
          this.countDown()
        })
        .catch(err => {
          captchaIns.refresh()
          this.captchainfo.isSend = false
        })
    },
    onSubmit() {
      if (!this.captchainfo.captcha) {
        return
      }
      let params = {
        mer: this.$route.query.mer,
        oldSn: this.$route.query.oldSn,
        newSn: this.$route.query.newSn,
        type: this.$route.query.type,
        smsCode: this.captchainfo.captcha
      }
      console.log('请求参数', params)
      multiChangeBind(params).then(res => {
        console.log(res)
        this.$toast('操作成功!')
        setTimeout(() => {
          window.SyHybridSdk.closeWebView({
            params: {},
            success: res => {}
          })
        }, 1500)
      })
    }
  }
}
</script>
